import getHashParams from '@/lib/getHashParams';
import Vue from 'vue';
import VueRouter, { NavigationGuard } from 'vue-router';

const World = () => import(/* webpackChunkName: "world" */ '@/views/World.vue');
const BuildingDetail = () =>
  import(/* webpackChunkName: "world" */ '@/views/BuildingDetail.vue');
const LearningPlan = () =>
  import(/* webpackChunkName: "world" */ '@/views/LearningPlan.vue');
const QuickNavigation = () =>
  import(/* webpackChunkName: "world" */ '@/views/QuickNavigation.vue');
const BadRequest = () =>
  import(/* webpackChunkName: "bad-request" */ '@/views/BadRequest.vue');
const Unauthorised = () =>
  import(/* webpackChunkName: "unauthorised" */ '@/views/Unauthorised.vue');
const Forbidden = () =>
  import(/* webpackChunkName: "forbidden" */ '@/views/Forbidden.vue');
const NotFound = () =>
  import(/* webpackChunkName: "not-found" */ '@/views/NotFound.vue');
const InvalidBrowser = () =>
  import(
    /* webpackChunkName: "invalid-browser" */ '@/views/InvalidBrowser.vue'
  );

Vue.use(VueRouter);

const beforeEnterHash: NavigationGuard = (to, from, next) => {
  if (!to.hash && from.hash) {
    // Get hash from previous route
    next({
      hash: from.hash,
      params: to.params,
      path: to.path,
      query: to.query,
      replace: true,
    });
  } else if ((!to.hash && !from.hash) || (to.hash && !getHashParams().jwt)) {
    // If no hash, no access
    next({
      name: 'Forbidden',
    });
  } else {
    next();
  }
};

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: World,
      children: [
        {
          path: '',
          name: 'World',
          beforeEnter: beforeEnterHash,
        },
        {
          path: 'building/:buildingId/catalogue/:catalogueId',
          component: BuildingDetail,
          children: [
            {
              path: '',
              name: 'Building',
              beforeEnter: beforeEnterHash,
            },
            {
              path: 'learning-plan/:learningPlanId',
              name: 'Learning Plan',
              component: LearningPlan,
              beforeEnter: beforeEnterHash,
            },
          ],
          beforeEnter: beforeEnterHash,
        },
        {
          path: 'quick-navigation',
          name: 'Quick Navigation',
          component: QuickNavigation,
          beforeEnter: beforeEnterHash,
        },
      ],
      beforeEnter: beforeEnterHash,
    },
    {
      path: '/400',
      name: 'Bad Request',
      component: BadRequest,
    },
    {
      path: '/401',
      name: 'Unauthorised',
      component: Unauthorised,
    },
    {
      path: '/403',
      name: 'Forbidden',
      component: Forbidden,
    },
    {
      path: '/invalid-browser',
      name: 'Invalid Browser',
      component: InvalidBrowser,
    },
    {
      path: '*',
      name: 'Not Found',
      component: NotFound,
    },
  ],
});

export default router;
